/**
 * @file
 * Link a block element (e.g. card) without wrapping it with an anchor tag.
 * Per default the first contained anchor will be used as target.
 * An alternative target child selector can be set with the attributes
 *   data-clickable value.
 *
 * @source https://design-system.w3.org/components/cards.html
 * @source https://css-tricks.com/block-links-the-search-for-a-perfect-solution/
 */

(function ($, Drupal) {
  Drupal.behaviors.clickable = {
    attach: function attach(context) {
      const clickableElements = once('clickable', '[data-clickable]', context);

      clickableElements.forEach(el => {
        const targetSelector = el.dataset.clickable ? el.dataset.clickable : 'a';
        const target = el.querySelector(targetSelector);

        if (target && target.nodeName === 'A') {
          // Prevent double event triggering on clickable elements like links and buttons.
          const clickableChildElements = el.querySelectorAll('a, button');
          clickableChildElements.forEach((childEl) =>
            childEl.addEventListener('click', e => e.stopPropagation())
          );

          el.addEventListener('click', e => {
            const isTargetClicked = e.target === target;
            if (isTargetClicked) {
              return;
            }
            const isTextSelected = window.getSelection().toString();
            if (isTextSelected) {
              return;
            }
            target.click();
          });

          el.classList.add('is-clickable');
        }
      });
    }
  };

})(jQuery, Drupal);
